export default () => {
  var $freeShippingProgress = $('.js-free-shipping-progress');
  if ($freeShippingProgress) {
    var $freeShippingMessage = $('.free-shipping-progress__message', $freeShippingProgress),
      $freeShippingProgressBar = $('.free-shipping-progress__progress', $freeShippingProgress),
      priceDifferenceUntilFreeShipping = $freeShippingProgress.attr('data-difference'),
      freeShippingMargin = parseFloat($freeShippingProgress.attr('data-free-shipping-margin')) + 0.01,
      percentageOfProgress = ((freeShippingMargin - priceDifferenceUntilFreeShipping) / freeShippingMargin) * 100;

    if (priceDifferenceUntilFreeShipping) {
      // see https://stackoverflow.com/questions/14826143/string-replaceall-is-not-working   - its best to escape the .
      $freeShippingMessage.html(
        'Noch ' +
          (Math.round(priceDifferenceUntilFreeShipping * 100) / 100).toFixed(2).replaceAll('\.', ',') +
          ' €, um versandkostenfrei zu bestellen.',
      );
      $freeShippingProgressBar.css('width', percentageOfProgress + '%');
    } else {
      console.log('priceDifferenceUntilFreeShipping... not available');
    }
  }
};
